<template>
  <div class="sf-col sf-xs-12 sf-md-6 sf-below-3">
    <div
      class="
        sf-layer-white sf-layer-rounded sf-layer-border sf-hover sf-full-height
      "
      data-walkthrough-id="chart-box"
    >
      <div class="sf-pad-h-3 sf-pad-v-2 sf-layer-border-bottom">
        <div
          :class="{
            'sf-level-between': canEditGraph,
            'sf-level-center': !canEditGraph,
          }"
          class="sf-level"
        >
          <div v-if="canEditGraph" class="sf-level-item"></div>
          <div class="sf-font-m sf-fwdb sf-c-text-dark sf-level-item">
            {{ title }}
          </div>
          <a
            v-if="canEditGraph"
            :href="reportGraphEditPath"
            class="sf-btn sf-btn-small sf-level-item sf-hover-item"
            >{{ I18n.t('common.edit') }}</a
          >
        </div>
      </div>
      <div class="sf-pad-3">
        <div class="sf-relative">
          <div class="sf-layer-rounded">
            <div ref="graph" class="report-graph"></div>
            <div v-if="!loaded" class="sf-spinner sf-align-c"></div>
            <div
              v-if="loaded && description"
              class="report-graph-description-wrapper"
            >
              <div class="sf-layer-rounded sf-layer-border-double sf-pad-3">
                <p v-dompurify-html="description"></p>
              </div>
            </div>
          </div>
          <a
            v-if="loaded"
            class="
              sf-btn
              sf-btn-small
              sf-btn-dark
              sf-stick-top
              sf-stick-right
              sf-hover-item
            "
            data-walkthrough-id="expand-chart"
            @click="zoomIn"
            ><span class="icon icon-expand sf-c-white"></span
          ></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import graphFetch from '../api/graph-fetch'
import buildGraph from '../../../handlers/build-graph'

const Graph = {
  props: {
    id: {
      type: Number,
      required: true,
    },
    reportTemplateId: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: false,
    },
    canEditGraph: {
      type: Boolean,
      required: true,
    },
    locale: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      loaded: false,
      report_graph: {},
    }
  },

  computed: {
    reportGraphEditPath() {
      return Silverfin.Routes.edit_report_template_report_graph_path({
        report_template_id: this.reportTemplateId,
        id: this.id,
        company_id: parseInt(Silverfin.currentCompanyId),
        firm_id: parseInt(Silverfin.currentFirmId),
        _options: true,
      })
    },
    reportGraphPath() {
      return (
        Silverfin.Routes.report_template_report_graph_path({
          report_template_id: this.reportTemplateId,
          id: this.id,
          company_id: parseInt(Silverfin.currentCompanyId),
          firm_id: parseInt(Silverfin.currentFirmId),
          _options: true,
        }) + `.json?language=${this.locale}`
      )
    },
  },

  mounted() {
    graphFetch(this.reportGraphPath).then((data) => {
      if (data) {
        this.report_graph = data
        this.loaded = true
        this.renderGraph()
      }
    })
  },

  methods: {
    renderGraph() {
      buildGraph(this.report_graph).render(this.$refs.graph)
    },

    zoomIn() {
      window.modalCitizen.openModal('view-graph-modal', {
        title: this.title,
        description: this.description,
        graphData: this.report_graph,
      })
    },
  },
}
export default Graph
</script>
